// firebaseFunctions.js
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import { db } from './firebase';

export const getPortfolio_details = async () => {
  const dataCol = collection(db, 'portfolio');
  const querySnapshot = await getDocs(query(dataCol));
  const data = querySnapshot.docs.map((doc) => ({
    key: doc.id,
    ...doc.data(),
  }));
  return data;
};


export const getSocial_link = async () => {
  const dataCol = collection(db, 'social_link');
  const querySnapshot = await getDocs(query(dataCol));
  const data = querySnapshot.docs.map((doc) => ({
    key: doc.id,
    ...doc.data(),
  }));
  return data;
};

export const getproject_list = async () => {
  const dataCol = collection(db, 'project_list');
  const querySnapshot = await getDocs(query(dataCol,orderBy("pro_post_date", "desc")));
  const data = querySnapshot.docs.map((doc) => ({
    key: doc.id,
    ...doc.data(),
  }));
  return data;
};

export const getExperience_list = async () => {
  const dataCol = collection(db, 'experience');
  const querySnapshot = await getDocs(query(dataCol,orderBy("pro_post_date", "desc")));
  const data = querySnapshot.docs.map((doc) => ({
    key: doc.id,
    ...doc.data(),
  }));
  return data;
};

// export const getEmployers = async () => {
//   const dataCol = collection(db, 'Employer_data');
//   const querySnapshot = await getDocs(query(dataCol));
//   const data = querySnapshot.docs.map((doc) => ({
//     key: doc.id,
//     ...doc.data(),
//   }));
//   return data;
// };

// export const getJobs = async () => {
//   const dataCol = collection(db, 'Vacancy_job_list');
//   const querySnapshot = await getDocs(query(dataCol));
//   const data = querySnapshot.docs.map((doc) => ({
//     key: doc.id,
//     ...doc.data(),
//   }));
//   return data;
// };

// export const getReferredJobs = async () => {
//   const dataCol = collection(db, 'Referral_list');
//   const querySnapshot = await getDocs(query(dataCol));
//   const data = querySnapshot.docs.map((doc) => ({
//     key: doc.id,
//     ...doc.data(),
//   }));
//   return data;
// };

// export const getJobsPostedCount = async () => {
//   const dataCol = collection(db, 'Vacancy_job_list');
//   const querySnapshot = await getDocs(query(dataCol));
//   return querySnapshot.size;
// };

// export const getCandidatesAppliedCount = async () => {
//   const dataCol = collection(db, 'User_Apply_job');
//   const querySnapshot = await getDocs(query(dataCol));
//   return querySnapshot.size;
// };

// export const getCandidatesHiredCount = async () => {
//   const dataCol = collection(db, 'User_Apply_job');
//   const querySnapshot = await getDocs(
//     query(dataCol, where('user_job_status', '==', '1'))
//   );
//   return querySnapshot.size;
// };

// export const getReferredCandidatesCount = async () => {
//   const dataCol = collection(db, 'Referral_list');
//   const querySnapshot = await getDocs(query(dataCol));
//   return querySnapshot.size;
// };

// export const getReferredHiredCount = async () => {
//   const dataCol = collection(db, 'Referral_list');
//   const querySnapshot = await getDocs(
//     query(dataCol, where('Referral_status', '==', '1'))
//   );
//   return querySnapshot.size;
// };

// export const fetchMatchingObject = async (idToSearch, setMatchingObject) => {
//   try {
//     // Create a reference to the collection
//     const collectionRef = collection(db, 'User_data');

//     // Create a query with the "where" condition to search for the specific ID
//     const q = query(collectionRef, where('uni_user_id', '==', idToSearch));

//     // Execute the query and get the documents
//     const querySnapshot = await getDocs(q);

//     // If there's a matching object, update the state with the first document data
//     if (!querySnapshot.empty) {
//       const matchingDoc = querySnapshot.docs[0];
//       setMatchingObject(matchingDoc.data());
//     } else {
//       setMatchingObject(null); // No matching object found
//     }
//   } catch (error) {
//     console.error('Error fetching data from Firebase: ', error);
//   }
// };

// export const fetchMatchingJob = async (idToSearch, setMatchingObject) => {
//   try {
//     // Create a reference to the collection
//     const collectionRef = collection(db, 'Vacancy_job_list');

//     // Create a query with the "where" condition to search for the specific ID
//     const q = query(collectionRef, where('vacancy_post_id', '==', idToSearch));

//     // Execute the query and get the documents
//     const querySnapshot = await getDocs(q);

//     // If there's a matching object, update the state with the first document data
//     if (!querySnapshot.empty) {
//       const matchingDoc = querySnapshot.docs[0];
//       setMatchingObject(matchingDoc.data());
//     } else {
//       setMatchingObject(null); // No matching object found
//     }
//   } catch (error) {
//     console.error('Error fetching data from Firebase: ', error);
//   }
// };
